<template>
  <div class="card shadow-sm border-0 rounded-4 h-100">
    <div class="card-body p-3">
      <div class="d-flex flex-column justify-content-between align-items-start gap-2 mb-2">
        <h6 class="text-uppercase text-muted m-0">Garantía</h6>
        <span class="badge rounded-pill px-3 py-1" :class="badgeClass">{{ label }}</span>
      </div>

      <h5 class="fw-semibold mb-1">{{ label }}</h5>
      <small class="text-muted d-block">Puntos: <strong>{{ computedPoints.toFixed(1) }}</strong> (0–20)</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollateralCard",
  props: {
    // Recibe el texto seleccionado en el <select> del padre (Mixta, Alta liquidez, Media, Baja, No hay)
    value: { type: String, default: "" },
    // v-model:points -> aporte al score total (0–20)
    points: { type: Number, default: 0 }
  },
  emits: ["update:points"],
  computed: {
    // Normaliza string (minúsculas, sin tildes) para comparar robusto
    norm() {
      const s = (this.value || "").toString().trim().toLowerCase();
      // quitar tildes
      return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    // Mapea texto -> puntos exactos
    computedPoints() {
      const n = this.norm;

      // Mixta
      if (n.includes("mixta")) return 20;

      // Alta liquidez (Hipotecaria)
      if (n.includes("alta") || n.includes("hipotec")) return 18;

      // Media (vehículo, maquinaria)
      if (n.includes("media")) return 12;

      // Baja
      if (n.includes("baja")) return 8;

      // No hay
      if (n.includes("no hay") || n === "" ) return 5;

      // Valor desconocido → asume conservador
      return 5;
    },

    // Etiqueta mostrada (usa lo que llega, con fallback)
    label() {
      const raw = (this.value || "").toString().trim();
      if (raw) return raw;
      // fallback por puntos
      const p = this.computedPoints;
      if (p >= 20) return "Mixta";
      if (p >= 18) return "Alta liquidez (Hipotecaria)";
      if (p >= 12) return "Media (vehículo, maquinaria)";
      if (p >= 8)  return "Baja";
      return "No hay";
    },

    // Color según categoría
    badgeClass() {
      const p = this.computedPoints;
      if (p >= 18) return "bg-success-subtle text-success-emphasis"; // Mixta / Alta
      if (p >= 12) return "bg-warning-subtle text-warning-emphasis"; // Media
      return "bg-danger-subtle text-danger-emphasis";                // Baja / No hay
    }
  },
  watch: {
    computedPoints: {
      immediate: true,
      handler(val) {
        this.$emit("update:points", Number(val.toFixed(1)));
      }
    }
  }
};
</script>

<style scoped>
/* Helpers por si tu build no trae subtle/emphasis */
.bg-success-subtle { background-color: rgba(25,135,84,.12) !important; }
.text-success-emphasis { color: #146c43 !important; }
.bg-warning-subtle { background-color: rgba(255,193,7,.15) !important; }
.text-warning-emphasis { color: #997404 !important; }
.bg-danger-subtle { background-color: rgba(220,53,69,.12) !important; }
.text-danger-emphasis { color: #842029 !important; }
</style>
